<template>
    <div class="fixed-menu-container">
        <!--        <div class="fixed-menu-screen-overlay"-->
        <!--             @click="close"-->
        <!--             v-if="isOpened"-->
        <!--        ></div>-->
        <div class="fixed-menu" :class="{ opened: isOpened }" v-click-outside="close">
            <div class="btn btn-container extra">
                <router-link to="/">
                    <transition name="fadex">
                        <div
                            class="btn menu-btn side-btn"
                            :class="{ active: !isAbout }"
                            v-if="isOpened"
                            @click="toggle"
                        >
                            <img src="../assets/icons/icon_poradnik.svg" alt="go to home" />
                        </div>
                    </transition>
                </router-link>
            </div>
            <div class="btn-container center">
                <div class="btn menu-btn dots-btn" @click="toggle">
                    <transition name="fade">
                        <img src="../assets/icons/icon_menu.svg" alt="open menu" v-if="!isOpened" />
                    </transition>
                    <transition name="fade">
                        <img
                            src="../assets/icons/icon_close-menu.svg"
                            alt="close menu"
                            v-if="isOpened"
                        />
                    </transition>
                </div>
            </div>
            <div class="btn btn-container extra">
                <router-link to="/info">
                    <transition name="fadex">
                        <div
                            class="btn menu-btn side-btn"
                            :class="{ active: isAbout }"
                            v-if="isOpened"
                            @click="toggle"
                        >
                            <img src="../assets/icons/icon_infokontakt.svg" alt="go to contact" />
                        </div>
                    </transition>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FixedMenu',
        data: function () {
            return {
                isOpened: false,
                isAbout: undefined,
            };
        },
        methods: {
            toggle: function () {
                this.isOpened = !this.isOpened;
            },
            close: function (event) {
                this.isOpened = false;
                event.stopPropagation();
                console.log(event);
            },
        },
        beforeMount() {
            const { name } = this.$router.currentRoute;
            this.isAbout = name === 'about';
        },
        watch: {
            $route({ name }) {
                this.isAbout = name === 'about';
            },
        },
    };
</script>

<style lang="scss">
    .fixed-menu-screen-overlay {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 300;
        background-color: red;
    }

    .fixed-menu-container {
        position: fixed;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 115px;
        left: 0;
        bottom: 30px;
        pointer-events: none;
        touch-action: none;
    }

    .fixed-menu {
        .center {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
        z-index: 900;
        display: flex;
        flex-flow: row nowrap;
        gap: 12vh;
        justify-content: space-between;
        align-items: center;
        width: 59px;
        height: 59px;
        padding: 18px;
        border-radius: 60px;
        box-shadow: 0 0 30px 0 rgba(2, 47, 41, 0.2);
        background-color: $white;
        pointer-events: auto;
        touch-action: auto;
        max-width: 300px;
        transition-timing-function: ease-out;
        transition-duration: 0.4s;
        transition-property: width, height, opacity, margin;

        &.opened {
            width: calc(100% - #{$margin * 2} - 36px);
            height: 79px;
        }

        &:not(.opened) {
            transition-delay: 0.3s;
        }

        .btn-container {
            display: flex;
            justify-content: space-around;
            flex-basis: 80px;

            a {
                -webkit-tap-highlight-color: transparent;
            }
        }

        .menu-btn {
            position: relative;
            flex-grow: 0;
            flex-shrink: 0;
            flex-basis: 60px;
            width: 60px;
            height: 60px;
            border-radius: 50px;
            margin-left: auto;
            margin-right: auto;

            img {
                position: absolute;
                left: 50%;
                top: 50%;
                width: 30px;
                transform: translate(-50%, -50%);
            }
        }

        .side-btn {
            background-color: $green;

            &.active {
                background-color: $gold;
                flex-basis: 80px;
                width: 80px;
                height: 80px;
            }
        }

        .dots-btn {
            background-color: $dark-green;
        }
    }

    .btn {
        outline: none;
        outline-style: none;
        box-shadow: none;
        border-color: transparent;
        background-color: none;
        color: none;

        a {
            text-decoration: none;
            &:link,
            &:visited,
            &:hover,
            &:active {
                color: none;
                background-color: none;
            }
        }
    }

    .fadex-enter-active,
    .fadex-leave-active {
        opacity: 1;
        transition: opacity 0.6s;
        transition-delay: 0.25s;
    }
    .fadex-enter, .fadex-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        transition: opacity 0.6s;
    }
</style>
